import { useMemo } from 'react';

import { IsValidCreateUploadResponse } from '@verantos-dev/types-concepts';

export const useValidationResultsCount = (concepts?: IsValidCreateUploadResponse[]) => {
  const { validConceptsCount, conceptsNotFoundCount, standardConceptsCount } = useMemo(() => {
    if (!concepts || concepts.length === 0) {
      return {
        validConceptsCount: 0,
        conceptsNotFoundCount: 0,
        standardConceptsCount: 0,
      };
    }

    return concepts.reduce(
      (counts, concept) => {
        if (concept.isValid) {
          counts.validConceptsCount++;

          if (concept.standardConcept === 'S') {
            counts.standardConceptsCount++;
          }
        } else {
          counts.conceptsNotFoundCount++;
        }

        return counts;
      },
      {
        validConceptsCount: 0,
        conceptsNotFoundCount: 0,
        standardConceptsCount: 0,
      }
    );
  }, [concepts]);

  const conceptsFoundCount = ((concepts && concepts.length) || 0) - conceptsNotFoundCount;
  const nonStandardConceptsCount = validConceptsCount - standardConceptsCount;

  return {
    conceptsFoundCount,
    conceptsNotFoundCount,
    validConceptsCount,
    standardConceptsCount,
    nonStandardConceptsCount,
  };
};
